import { ApiRequestConfig, api } from '@comall-backend-builder/core/lib/services/api';

export const CategoryBaseInfoLoader = {
    get: async function(params: any, config: ApiRequestConfig) {
        config.apiPath = `/display_category/${params.categoryId}/base_info`;
        return api.get(params, config);
    },
    put: async function(params: any, config: ApiRequestConfig) {
        if (params.imgPcUrl && typeof params.imgPcUrl !== 'string') {
            params.imgPcUrl = params.imgPcUrl.path ? params.imgPcUrl.path : '';
        }
        if (params.imgAppUrl && typeof params.imgAppUrl !== 'string') {
            params.imgAppUrl = params.imgAppUrl.path ? params.imgAppUrl.path : '';
        }
        config.apiPath = `/display_category/${params.categoryId}/base_info`;
        return api.put(params, config);
    },
    post: async function(params: any, config: ApiRequestConfig) {
        config.apiPath = `/display_category/add_display_category`;
        if (isNaN(params.sequence)) {
            params.sequence = 0;
        }
        return api.post(params, config);
    },
};

// 展示图设置
export const CategoryBaseInfoThreeLoader = {
    get: async function(params: any, config: ApiRequestConfig) {
        console.log(params);
        config.apiPath = `/display_category/${params.parentId}/base_info`;
        const response: any = await api.get(params, config);
        if (response && !!response.imgType) {
            return { imgType: response.imgType };
        } else {
            return {};
        }
    },
    put: async function(params: any, config: ApiRequestConfig) {
        config.apiPath = `/display_category/add_display_category`;
        if (isNaN(params.sequence)) {
            params.sequence = 0;
        }
        return api.post(params, config);
    },
};

export const CategoryTreeLoader = {
    get: async function(params: any, config: ApiRequestConfig) {
        config.apiPath = `/display_category/tree`;
        return api.get<any>(params, config).then((response) => {
            return response ? [response] : [];
        });
    },
};

export const CategoryUnionProductLoader = {
    get: async function(params: any, config: ApiRequestConfig) {
        config.apiPath = `/display_category/${params.categoryId}/union_product`;
        return api.get(params, config);
    },
    post: async function(params: any, config: ApiRequestConfig) {
        config.apiPath = `/display_category/${params.categoryId}/union_product`;
        return api.post(params, config);
    },
    delete: async function(params: any, config: ApiRequestConfig) {
        const type = params.type;
        delete params.type;
        switch (type) {
            case 'all':
                config.apiPath = `/display_category/${params.categoryId}/union_product/all`;
                break;
            case 'batch':
                config.apiPath = `/display_category/${params.categoryId}/union_product/batch`;
                // 对于批量操作要转发成POST
                return api.post(params, config);
            default:
                config.apiPath = `/display_category/${params.categoryId}/${params.id}/union_product`;
                break;
        }
        return api.delete(params, config);
    },
};

export const CategoryUnionProductTypeLoader = {
    get: async function(params: any, config: ApiRequestConfig) {
        config.apiPath = `/display_category/${params.categoryId}/union_product/union_type`;
        return api.get(params, config);
    },
    put: async function(params: any, config: ApiRequestConfig) {
        config.apiPath = `/display_category/${params.categoryId}/union_product/union_type`;
        return api.put(params, config);
    },
};

export const CategoryFilterAttrLoader = {
    get: async function(params: any, config: ApiRequestConfig) {
        config.apiPath = `/display_category/${params.categoryId}/filter_attr`;
        return api.get(params, config);
    },
    post: async function(params: any, config: ApiRequestConfig) {
        config.apiPath = `/display_category/${params.categoryId}/filter_attr`;
        return api.post(params, config);
    },
    delete: async function(params: any, config: ApiRequestConfig) {
        const type = params.type;
        delete params.type;
        switch (type) {
            case 'all':
                config.apiPath = `/display_category/${params.categoryId}/filter_attr/all`;
                break;
            case 'batch':
                config.apiPath = `/display_category/${params.categoryId}/filter_attr/batch`;
                // 对于批量操作要转发成POST
                return api.post(params, config);
            default:
                config.apiPath = `/display_category/${params.categoryId}/${params.id}/filter_attr`;
                break;
        }

        return api.delete(params, config);
    },
    put: async function(params: any, config: ApiRequestConfig) {
        config.apiPath = `/display_category/${params.categoryId}/${params.id}/order?sequence=${params.sequence}`;
        return api.put({}, config);
    },
};
